import React from "react";
import styled from "@emotion/styled";
import { MoreVertical } from "react-feather";

import {
  Card as MuiCard,
  CardHeader,
  IconButton,
  Chip as MuiChip,
  Paper as MuiPaper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { spacing } from "@mui/system";

const Card = styled(MuiCard)(spacing);

const Chip = styled(MuiChip)`
  height: 20px;
  padding: 4px 0;
  font-size: 90%;
  background-color: ${(props) =>
    props.theme.palette[props.color ? props.color : "primary"].light};
  color: ${(props) => props.theme.palette.common.white};
`;

const Paper = styled(MuiPaper)(spacing);

const TableWrapper = styled.div`
  overflow-y: auto;
  max-width: calc(100vw - ${(props) => props.theme.spacing(12)});
`;

function safeStr(v) {
  if (v === null || v === undefined) return "";
  return String(v);
}

const DashboardTable = ({ failures = [], chartLinkMap = {} }) => (
  <Card mb={6}>
    <CardHeader
      action={
        <IconButton aria-label="settings" size="large">
          <MoreVertical />
        </IconButton>
      }
      title="Latest failures"
    />
    <Paper>
      <TableWrapper>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Location</TableCell>
              <TableCell>Asset</TableCell>
              <TableCell>Chart</TableCell>
              <TableCell>Reason</TableCell>
              <TableCell>Tester</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {failures.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7}>
                  <Chip label="No failures" color="success" />
                </TableCell>
              </TableRow>
            ) : (
              failures.map((f) => {
                const chart = safeStr(f?.chart);
                const link = chart ? chartLinkMap[chart] : "";
                return (
                  <TableRow
                    key={safeStr(f?.itemId) || `${chart}-${safeStr(f?.asset)}`}
                  >
                    <TableCell>{safeStr(f?.location)}</TableCell>
                    <TableCell>{safeStr(f?.asset)}</TableCell>
                    <TableCell>
                      {link ? (
                        <a href={link} target="_blank" rel="noreferrer">
                          {chart}
                        </a>
                      ) : (
                        chart
                      )}
                    </TableCell>
                    <TableCell>{safeStr(f?.reason)}</TableCell>
                    <TableCell>{safeStr(f?.tester)}</TableCell>
                    <TableCell>{safeStr(f?.date)}</TableCell>
                    <TableCell>{safeStr(f?.description)}</TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableWrapper>
    </Paper>
  </Card>
);

export default DashboardTable;
